import { useState } from "react";

import { Autocomplete, Box, Drawer, FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import '../../css/searchPage.css'

import { UseGetFlag } from "../../app/launchDarkly";
import { setCuisineFilter, setIngredientFilter, setMealTypeFilter, setTimeFilter } from "../../app/search/search.slice";
import { applySearchFilters, clearSearchFilters } from "../../app/search/search.thunk";
import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import { ReactComponent as CheckBoxIcon } from "../../svg/checkBoxIcon.svg";
import { ReactComponent as CheckBoxIconFilled } from "../../svg/checkBoxIconFilled.svg";
import { ReactComponent as SearchIcon } from "../../svg/searchIcon.svg";
import { TextPrimary, TextSmallBold } from "../typography";
import FilterButton from "./filterButton";

const Filter = () => {
	const [drawer, setDrawer] = useState(false)
	const [filterArray, setFilterArray] = useState<any>(null)
	const ingredientsNameList = useAppSelector((state) => state.search.ingredientsNameList);
	const mealTypeNameList = useAppSelector((state) => state.search.mealTypeList);
	const cuisine = useAppSelector((state) => state.search.cuisineNameList);
	const searchFilters = useAppSelector((state) => state.search.searchFilters);
	const [selected, setSelected] = useState<any>([])
	const dispatch = useAppDispatch();
	const { enableAdminFeatures, enableAlgoliaSearch } = UseGetFlag()

	function handleClose() {
		setDrawer(false)
	}
	function clearFilter() {
		dispatch(clearSearchFilters(enableAdminFeatures));
		setSelected([])
		handleClose();
	}

	function applyFilter() {
		dispatch(applySearchFilters({ enableAdminFeatures, enableAlgoliaSearch }));
		handleClose();
	}
	function menuSelection(type: string) {
		if (type === 'ingredient') {
			dispatch(setIngredientFilter(selected))
			applyFilter()
		}
		else if (type === 'cuisine') {
			dispatch(setCuisineFilter(selected));
			applyFilter()
		}
		else if (type === 'time') {
			dispatch(setTimeFilter(selected))
			applyFilter()
		}
		else if (type === 'meal') {
			dispatch(setMealTypeFilter(selected))
			applyFilter()
		}
	}

	const filterFunc = (type: string) => {
		setDrawer(true)
		switch (type) {
			case 'Ingredients':
				setFilterArray({
					placeHolder: 'Search ingredients',
					selectionType: 'multiple',
					search: true,
					autocomplete: true,
					filterArrayValues: ingredientsNameList,
					keyName: false,
					button1: 'Clear All',
					button2: 'Apply Filters',
					type: 'ingredient',
				})
				setSelected(searchFilters.ingredientFilter)
				break;
			case 'Cuisines':
				setFilterArray({
					placeHolder: 'Search cuisines',
					selectionType: 'multiple',
					search: true,
					autocomplete: true,
					filterArrayValues: cuisine,
					keyName: false,
					button1: 'Clear All',
					button2: 'Apply Filters',
					type: 'cuisine'
				})
				setSelected(searchFilters.cuisineFilter)
				break;
			case 'Time':
				setFilterArray({
					selectionType: 'multiple',
					search: false,
					autocomplete: false,
					filterArrayValues: [
						{ label: 'Any' },
						{ label: 'Below 30 mins' },
						{ label: 'More than 30 mins' }
					],
					keyName: 'label',
					button1: 'Clear',
					button2: 'Apply',
					type: 'time'
				})
				setSelected(searchFilters.timeFilter)
				break;
			case 'Meal':
				setFilterArray({
					placeHolder: 'Search cuisines',
					selectionType: 'multiple',
					search: false,
					autocomplete: true,
					filterArrayValues: mealTypeNameList,
					keyName: false,
					button1: 'Clear All',
					button2: 'Apply Filters',
					type: 'meal'
				})
				setSelected(searchFilters.mealTypeFilter)
				break;
			default:
				throw new Error(`Invalid filter type: ${type}`);
		}
	}

	return (
		<Box sx={{ backgroundColor: '#FCF8EA', mx: 2, mt: 2 }}>
			<TextSmallBold color='#000' text='Filter by:' />
			<Box className='filterSection' sx={{ backgroundColor: '#FCF8EA', display: 'flex', alignItems: 'center', mt: 1, gap: 2, overflow: 'scroll' }}>
				<FilterButton
					badge={searchFilters.ingredientFilter.length}
					borderBool={searchFilters.ingredientFilter?.length > 0}
					onClick={() => filterFunc('Ingredients')}
					text="What's&nbsp;in&nbsp;my&nbsp;fridge?" />
				<FilterButton
					badge={searchFilters.cuisineFilter.length}
					borderBool={searchFilters.cuisineFilter?.length > 0}
					onClick={() => filterFunc('Cuisines')}
					text="Cuisines" />
				<FilterButton
					badge=''
					borderBool={searchFilters.timeFilter !== '' && searchFilters.timeFilter !== 'Any'}
					onClick={() => filterFunc('Time')}
					text='Cooking&nbsp;Time' />
				<FilterButton
					badge={searchFilters.mealTypeFilter.length}
					borderBool={searchFilters.mealTypeFilter.length > 0}
					onClick={() => filterFunc('Meal')}
					text="Meal&nbsp;Type" />
			</Box>
			<Drawer anchor='bottom' className='filterDrawer' onClose={() => setDrawer(false)}
				open={drawer} sx={{ borderRadius: '20px 20px 0 0' }}>
				<Box className={filterArray?.search ? "drawer1" : 'drawer2'}
					sx={{ height: '70vh', backgroundColor: '#FCF8EA', position: 'relative' }}>
					<Box sx={{ m: 2, display: 'flex', flexDirection: 'column', mt: filterArray?.search || !filterArray?.autocomplete ? 2 : '-40px' }}>
						{filterArray?.autocomplete ?
							<>
								<Box sx={{ position: 'absolute', marginLeft: '12px', marginTop: 1, zIndex: 99 }}>
									<SearchIcon />
								</Box>
								<Autocomplete
									disablePortal
									freeSolo
									getOptionLabel={(option: any) => (filterArray?.keyName ? option[filterArray?.keyName] : option)}
									id="combo-box-demo"
									limitTags={1}
									multiple
									onChange={(event, value) => setSelected(value)}
									open
									options={filterArray?.filterArrayValues}
									renderInput={(params) =>
										<TextField {...params}
											className='searchPage'
											placeholder={filterArray?.placeHolder}
											sx={{ backgroundColor: '#fff', outline: 0, borderRadius: '10px' }}
										/>
									}
									renderOption={(props, option: any, { selected }) => (
										<li {...props}>
											<>
												<Box style={{ display: selected ? "block" : "none" }} sx={{ width: 10, height: 23 }}><CheckBoxIconFilled /></Box>
												<Box style={{ display: selected ? "none" : "block" }} sx={{ width: 10, height: 23 }}><CheckBoxIcon /></Box>
											</>
											<Box sx={{ flexGrow: 1, fontSize: '15px', ml: 2 }}>{filterArray?.keyName ? option[filterArray?.keyName] : option}</Box>
										</li>
									)
									}
									sx={{ width: '100%' }}
									value={selected}
								/>
							</> :
							<Box sx={{ m: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
								<RadioGroup
									aria-labelledby="demo-radio-buttons-group-label"
									defaultValue={selected}
									onChange={(event, value) => setSelected(value)}
								>
									{filterArray?.filterArrayValues?.map((filterValue: any) => (
										<FormControlLabel control={<Radio />} label={<TextPrimary text={filterValue[filterArray?.keyName]} />} value={filterValue[filterArray?.keyName]} />
									))}
								</RadioGroup>
							</Box>
						}
						<Box sx={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', bottom: 10, zIndex: 20, width: '90%', backgroundColor: '#FCF8EA', pt: 1 }}>
							<Box onClick={() => clearFilter()} sx={{ p: 2, color: '#FF0000', width: '40%', textAlign: 'center', fontSize: '17px', fontWeight: 400 }}>
								{filterArray?.button1}
							</Box>
							<Box onClick={() => menuSelection(filterArray?.type)} sx={{ p: 2, color: '#FFF', backgroundColor: '#3B1F8E', width: '40%', textAlign: 'center', borderRadius: '10px', fontSize: '17px', fontWeight: 600 }}>
								{filterArray?.button2}
							</Box>
						</Box>
					</Box>
				</Box>
			</Drawer>
		</Box>
	)
};

export default Filter;